import { getRandomColor } from "../../../helpers/helper";
import { getGraphDetails } from "./ChartUtils";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const CustomAreaChart = ({
  maxHeight,
  chartData,
  seriesMap,
  compact = true,
  style={}
}) => {
  const [xDataKey, yDataKeys, data] = getGraphDetails(chartData, seriesMap);
  const tooltipLabelFormatter = (_, payload) => {
    const p = payload?.[0]?.payload || {};
    return p[xDataKey] ?? p.label ?? ""; // LABEL (X)
  };
  return (
    <AreaChart
      style={{
        width: compact ? 80 : "100%",
        height : compact ? "100%":80,
        
        aspectRatio: 2,
        ...style
      }}
      responsive
      data={data}
      margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
    >
      <defs>
        {yDataKeys.map((key) => {
          const rand = getRandomColor();
          return (
            <linearGradient id={`color-${key}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={rand} stopOpacity={0.8} />
              <stop offset="95%" stopColor={rand} stopOpacity={0} />
            </linearGradient>
          );
        })}
      </defs>
      {/* <CartesianGrid strokeDasharray="3 3" />  */}
      {/* {!compact && <XAxis dataKey={xDataKey} />}
      {!compact && <YAxis width="auto" />} */}
            <Tooltip
        labelFormatter={tooltipLabelFormatter}
        position={{ x: 0, y: -100 }}
        wrapperStyle={{ zIndex: 2147483647 }}
      />



      {yDataKeys.map((key) => {
        return (
          <Area
          type="monotone"
            dataKey={key}
            stroke={getRandomColor()}
            fillOpacity={1}
            fill={`url(#color-${key})`}
            isAnimationActive={true}
          />
        );
      })}
     
    </AreaChart>
  );
};

export default CustomAreaChart;
